const parallaxScrollInit = () => {
  const sections = document.querySelectorAll('.static-parallax--scroll');

  if (sections.length > 0) {
    sections.forEach((section) => {

      const applyParallaxEffect = () => {
        const scrollTop = window.scrollY;
        const offsetTop = section.offsetTop;

        const speedCount = parseFloat(section.getAttribute('data-parallax-speed')) || 0;
        let speed = 0;

        if (speedCount > 0 && speedCount !== 10) {
          speed = speedCount / 100;
        } else if (speedCount === 10) {
          speed = speedCount / 100;
        }

        const movementValue = -(scrollTop - offsetTop) * speed;
        section.style.setProperty('--parallax-transform', `${movementValue}px`);
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', applyParallaxEffect);
              applyParallaxEffect();
            } else {
              window.removeEventListener('scroll', applyParallaxEffect);
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      observer.observe(section);
      applyParallaxEffect();
    });
  }
};

parallaxScrollInit();

document.addEventListener('shopify:section:load', (event) => {
  parallaxScrollInit();
});